export default __webpack_public_path__ + "static/media/July2008.0bde05f9.png";